const configuracaoRoutes = [
  {
    path: '/config-vtex/ativacao',
    name: 'configVtex.ativacao',
    component: () => import('../views/configVtex/Ativacao.vue'),
  },
  {
    path: '/config-vtex/estoque',
    name: 'configVtex.estoque',
    component: () => import('../views/configVtex/Estoque.vue'),
  },
  {
    path: '/config-vtex/integracao',
    name: 'configVtex.integracao',
    component: () => import('../views/configVtex/Integracao.vue'),
  },
  {
    path: '/config-vtex/produtos',
    name: 'configVtex.produtos',
    component: () => import('../views/configVtex/Produtos.vue'),
  },
  {
    path: '/config-vtex/condicoes-pagamento',
    name: 'configVtex.condicoespagamento',
    component: () => import('../views/configVtex/Condicoes.vue'),
  },
  {
    path: '/config-eloca/ativacao',
    name: 'configEloca.ativacao',
    component: () => import('../views/configEloca/Ativacao.vue'),
  },
  {
    path: '/config/fluxo-trabalho',
    name: 'config.fluxoTrabalho',
    component: () => import('../views/config/FluxoTrabalho.vue'),
  },
  {
    path: '/config/datavalid',
    name: 'config.dataValid',
    component: () => import('../views/config/DataValid.vue'),
  },
  {
    path: '/config/importar-certificado',
    name: 'config.importarCertificado',
    component: () => import('../views/config/ImportarCertificado.vue'),
  },
  {
    path: '/config/upload-imagem-login',
    name: 'config.uploadImagemLogin',
    component: () => import('../views/config/UploadImagemLogin.vue'),
  },
  {
    path: '/config-rd/ativacao',
    name: 'configRD.ativacao',
    component: () => import('../views/configRDStation/Ativacao.vue'),
  },
  {
    path: '/config/ifood',
    name: 'config.ifood',
    component: () => import('../views/config/IntegracaoIfood.vue'),
  },
  {
    path: '/config/aplicativo',
    name: 'config.aplicativo',
    component: () => import('../views/config/Aplicativo.vue'),
  },
];

export default configuracaoRoutes;
